
const storiesReducer = (state={}, action)=>{
  switch (action.type) {
    case 'LOGOUT':
     return {}
    case 'ADD_STORIES':
      return {
       ...state,
       ...action.payload.data.entities.stories
      }
    default:
      return state
  }
}


export default storiesReducer;



// WEBPACK FOOTER //
// ./src/utils/reducers/stories.js